import { COMPANY } from '../../mocks/siteData';

const stats = [
  { value: `${COMPANY.yearsExp}+`, label: 'Years Experience', icon: 'ri-history-line' },
  { value: `${COMPANY.rating}★`, label: `${COMPANY.reviewCount} Verified Reviews`, icon: 'ri-star-fill' },
  { value: '100%', label: 'Licensed & Insured', icon: 'ri-shield-check-line' },
  { value: 'Brandon', label: 'FL Local Specialists', icon: 'ri-map-pin-2-line' },
  { value: 'Free', label: 'In-Home Consultation', icon: 'ri-home-smile-line' },
];

export default function TrustBar() {
  return (
    <section className="bg-stone-950 border-y border-stone-800/60">
      <div className="px-6 lg:px-16 xl:px-24 py-0">
        <div className="flex flex-wrap items-stretch justify-center divide-x divide-stone-800/60">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="flex items-center gap-3 px-8 py-5 group"
            >
              <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                <i className={`${stat.icon} text-accent text-base`} />
              </div>
              <div>
                <p className="text-white font-semibold text-sm leading-none mb-0.5 whitespace-nowrap font-sans">{stat.value}</p>
                <p className="text-stone-500 text-xs whitespace-nowrap leading-none">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
